import {withSentryErrorBoundary} from '@wix/native-components-infra/dist/es/src/HOC/sentryErrorBoundary/sentryErrorBoundary';
import {ProductWidgetApp} from './ProductWidgetApp';
import {bootstrapApp} from '../../commons/bootstrap';
import {PRODUCT_WIDGET_DSN} from '@wix/wixstores-client-storefront-sdk/dist/es/src/viewer-script/sentryConf';
import {withStyles} from '@wix/native-components-infra/dist/es/src/HOC/withStyles/withStyles';

export const component = withSentryErrorBoundary(bootstrapApp(ProductWidgetApp, withStyles), {
  dsn: PRODUCT_WIDGET_DSN,
  config: {environment: 'Native Component'},
});
